import type { ComponentProps } from "react";
import { DashboardView } from "@/components/dashboard/dashboard-view";
import { DashboardSkeleton } from "@/components/page-skeletons";
import { ViewFallback } from "@/components/page-states";
import { usePageTitle, useView } from "@shared/client/view";
import { useT } from "@shared/client/locale";

type DashboardData = ComponentProps<typeof DashboardView>;

export default function DashboardPage() {
  const t = useT();
  usePageTitle(t.dashboard.page.title);
  const { data, error } = useView<DashboardData>("/api/views/dashboard");
  if (!data) return <ViewFallback error={error} skeleton={<DashboardSkeleton />} subject={t.dashboard.page.subject} />;
  return <DashboardView {...data} />;
}
